import * as React from 'react'

import { Spacer } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../../lib/analytics'
import { formatPrettyColorName } from '../../../../../../lib/utils'
import { SectionLabelWrapper, SectionSubtitle, SectionTitle, SoldOutMessage } from '../styles'

import { IProps } from './IProps'
import { Container, StyledColorSelector } from './styles'

export const ColorsSection: React.FC<IProps> = ({
  colors,
  hasSelectedSize,
  isCurrentColorCompletelySoldOut,
  isProductWaitlistable,
  onColorSelect,
  selectedColorKey,
  disableMobileHorizontalSwipe,
}) => {
  const {
    detailsSection: { colorTitle, soldOutSectionTitleMessage },
  } = useTranslation()

  const selectedColor = colors.find(c => c.rawName == selectedColorKey)
  let titleColor = selectedColor?.name ?? ''

  return (
    <Container>
      <SectionLabelWrapper>
        <SectionTitle asTag='p'>{colorTitle}</SectionTitle>

        {selectedColorKey && (
          <SectionSubtitle
            {...trackEvent({
              category: 'product details',
              action: 'snapshot',
              label: 'color',
              value: `${selectedColorKey}`,
            })}
          >
            {formatPrettyColorName(titleColor)}
            {isCurrentColorCompletelySoldOut && !hasSelectedSize && !isProductWaitlistable && (
              <SoldOutMessage>&nbsp;{soldOutSectionTitleMessage}</SoldOutMessage>
            )}
          </SectionSubtitle>
        )}
      </SectionLabelWrapper>

      <Spacer height={8} />

      <StyledColorSelector
        colors={colors}
        selectedColorKey={selectedColorKey}
        disableMobileHorizontalSwipe={disableMobileHorizontalSwipe}
        data-testid='color-swatch-picker'
        onSelectColor={onColorSelect}
        {...trackEvent({
          category: 'product details',
          action: 'select color',
          label: selectedColorKey,
          value: selectedColorKey,
        })}
      />
    </Container>
  )
}
